import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Auto-scroll to top whenever the route path changes.
 * Skipped when the URL contains a hash (#features, etc.) so anchor jumps still work.
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) return;
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname, hash]);
    return null;
}
